import { type ModalRegistration } from '@/shared/components/Modals/modal-registry/modal-registry.types';

import { LegalDocumentFormModal } from '../components/LegalDocumentFormModal/LegalDocumentFormModal';
import { PublishVersionModal } from '../components/PublishVersionModal/PublishVersionModal';

export const LEGAL_MODALS = {
  DOCUMENT_FORM: 'legal.document-form',
  PUBLISH_VERSION: 'legal.publish-version',
} as const;

export const legalModals: readonly ModalRegistration[] = [
  { modalTypes: [LEGAL_MODALS.DOCUMENT_FORM], component: LegalDocumentFormModal },
  { modalTypes: [LEGAL_MODALS.PUBLISH_VERSION], component: PublishVersionModal },
];
